import { ContentTableInterface } from 'common/types/entities/ContentTableInterface'

export function getContentTableFontProperties(entity: ContentTableInterface) {
  const fontProperties = []

  if (entity.headerFontFamily) {
    fontProperties.push({
      fontFamily: entity.headerFontFamily,
      fontStyle: entity.headerFontStyle,
      fontWeight: entity.headerFontWeight,
    })
  }

  if (entity.contentFontFamily) {
    fontProperties.push({
      fontFamily: entity.contentFontFamily,
      fontStyle: entity.contentFontStyle,
      fontWeight: entity.contentFontWeight,
    })
  }

  return fontProperties
}

export function getContentTableCustomFontProperties(
  entity: ContentTableInterface,
) {
  const fontProperties = []

  if (entity.headerFontFamily && entity.headerFontFileId) {
    fontProperties.push({
      fontFamily: entity.headerFontFamily,
      fontFileId: entity.headerFontFileId,
    })
  }

  if (entity.contentFontFamily && entity.contentFontFileId) {
    fontProperties.push({
      fontFamily: entity.contentFontFamily,
      fontFileId: entity.contentFontFileId,
    })
  }

  return fontProperties
}
